import { createStore, applyMiddleware } from "redux";

import thunk from "redux-thunk";
import reducer from "./redux/reducers/";
const middleware = applyMiddleware(thunk);

let store = createStore(reducer, middleware);
export { store };
